<template>
  <v-dialog scrollable max-width="1200px" v-model="model" persistent>
    <material-card
      :title="$t('components.plan_benefit_rules.rules_types_dialog.title')"
      :color="$vuetify.theme.themes.light.success"
      icon="add"
    >
      <v-card-text>
        <!-- <v-row>
          <v-col v-for="(ruleType,index) in ruleTypes" :key="index">
            <rule-type-help-tile :ruleType="ruleType" />
          </v-col>
        </v-row> -->
        <rule-type-help-tile v-for="(ruleType,index) in ruleTypes" :key="index" :ruleType="ruleType" />
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="$emit('close')">
          {{ $t("globals.close") }}
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import RuleTypeHelpTile from "./RuleTypeHelpTile.vue";
export default {
  props: ["model", "ruleTypes"],
  components:{
    RuleTypeHelpTile
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("plansMembers", ["options"]),
    ...mapGetters("common", ["language"]),
  },
  // watch: {
  //   model: {
  //     handler(v) {
  //       if (v) {

  //       }
  //     },
  //   },
  // },
};
</script>

<style></style>
